import Controller from '@ember/controller';
import { type Registry as Services, service } from '@ember/service';
import type HotelChannelManagerRoute from 'lumen/routes/hotel/channel-manager';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelChannelManagerController extends Controller {
  declare model: ModelFrom<HotelChannelManagerRoute>;

  @service declare access: Services['access'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isManualRedirectFlow() {
    return this.access.user.hasMultipleSubscriptions;
  }
}
